export var PayoutIntegrationStatus = /*#__PURE__*/ function(PayoutIntegrationStatus) {
    PayoutIntegrationStatus["Synced"] = "synced";
    PayoutIntegrationStatus["SyncFailed"] = "syncFailed";
    PayoutIntegrationStatus["PendingSync"] = "pendingSync";
    PayoutIntegrationStatus["SyncInProgress"] = "syncInProgress";
    PayoutIntegrationStatus["Deleted"] = "deleted";
    return PayoutIntegrationStatus;
}({});
